export enum UserRole {
    Administrator = 'Administrator',
    BrandAdmin = 'BrandAdmin',
    Authority = 'Authority',
}
